import { FlexRow } from "@similarweb/ui-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

export const ItemWrapper = styled(FlexRow)`
    padding: 12px 16px 16px;

    justify-content: space-between;
`;

export const ItemText = styled.p`
    margin: 0;
    ${setFontVariant('sectionTitle', colorsPalettes.carbon[500])}
    font-family: Roboto;
    font-weight: 500;
`;